import React from "react";

function Emailpop({ isCopy }) {
  return (
    <div className="email-popUp">
      <div className="para emailPop-text">Email Copied!</div>
    </div>
  );
}

export default Emailpop;
